export class InfectedDateSize {
    'date';
    'sizeBytes';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "date",
            "baseName": "date",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "sizeBytes",
            "baseName": "sizeBytes",
            "type": "number",
            "format": "int64"
        }
    ];
    static getAttributeTypeMap() {
        return InfectedDateSize.attributeTypeMap;
    }
    constructor() {
    }
}
